import { apiMipe, api } from '@/core/api/';

export default {
  getRegions(properties) {
    return apiMipe.get('api/location/regions', {
      params: {
        ...properties,
      },
    });
  },
  getDistricts(properties) {
    return apiMipe.get('api/location/districts', {
      params: {
        ...properties,
      },
    });
  },
  getMunicipalities(properties) {
    return api.get('api/location/municipalities', {
      params: {
        ...properties,
      },
    });
  },
  getLocationService(properties) {
    return api.get('api/location/locationservice', {
      params: {
        ...properties,
      },
    });
  },
  getSchools(properties) {
    return api.get('api/location/schools', {
      params: {
        ...properties,
      },
    });
  },
  getCenters(properties) {
    return api.get('api/location/centers', {
      params: {
        ...properties,
      },
    });
  },
  getAllCenters() {
    return api.get('api/location/allcenters');
  },

  getHealthRegions(properties) {
    return api.get('api/location/healthregions',{
      params: {
        ...properties,
      },
    });
  },
  
  getBillingCenters(properties) {
    return api.get('api/location/billingcenters', {
      params: {
        ...properties,
      },
    });
  },
  getUsersSchool(properties) {
    return api.get('api/schools/users', {
      params: {
        ...properties,
      },
    });
  },
  userHasSchoolsAttached(properties) {
    return apiMipe.get('api/location/userhasschoolsattached', {
      params: {
        ...properties,
      },
    });
  },

  getLocationTypes() {
    return api.get('api/location/locationtypes');
  },

  getProviderLocations(academicYearId, companyId, locationTypeId) {
    return api.get('api/location/providerlocations', {
      params: {
        academicYearId: academicYearId,
        companyId: companyId,
        locationTypeId: locationTypeId,
      },
    });
  },
  getActiveRegions() {
    return apiMipe.get('api/location/activeregions');
  },
  getOres() {
    return api.get('api/location/ores');
  },
};
